import React, { useEffect } from 'react';
import useFlatData from '../../../Base/Hooks/useFlatData';
import { useAppContext } from '../../../../Services/AppContext';
import {
	CaseType,
	useLazyMonitoringCentreCasesQuery,
} from '../../../../graphql/graphql';
import useCases from '../../../Case/Hooks/useCases';
import MonitoringCenterList from '../MonitoringCenterList/MonitoringCenterList';
// @ts-ignore
import styles from './MonitoringCenterNewRequestsItem.module.scss';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { MonitoringCenterNewRequestsFilterValues } from './MonitoringCenterNewRequestsFilter';
import useSocket from '../../../Base/Hooks/useSocket';
import { Socket } from '../../../Base/Enums/Socket.enum';

interface Props {
	filter?: MonitoringCenterNewRequestsFilterValues;
	caseType: CaseType;
	onBack: () => void;
}

const MonitoringCenterNewRequestsItemDetail: React.FC<Props> = ({
	filter,
	caseType,
	onBack,
}) => {
	const [getWorkplaceCasesQuery, { data, isLoading }] =
		useLazyMonitoringCentreCasesQuery();
	const { getWorkplaceCases, getNextPage, page, setPage } = useCases(
		getWorkplaceCasesQuery,
		40,
	);

	useEffect(() => {
		if (filter) {
			setFilter({ ...filter, caseTypeCode: caseType.code });
		}
	}, [filter]);

	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getWorkplaceCases,
		{
			data: data?.monitoringCentreCases?.data,
			totalPages: data?.monitoringCentreCases?.meta?.totalPages,
			page: data?.monitoringCentreCases?.meta?.page,
		},
		page,
		setPage,
		{ caseTypeCode: caseType.code },
	);

	useSocket(Socket.CASE_TAKEN, loadData);

	return (
		<div className={styles.wrapper}>
			<div className={styles.titleWrapper}>
				<div className={styles.title}>
					<div>{caseType.label}</div>
					<div className={styles.count}>
						{data?.monitoringCentreCases?.meta?.count}
					</div>
				</div>
				<div>
					<LinkButton
						title='base.shared.back'
						theme={Theme.BLUE}
						onClick={onBack}
						firstUpper
					/>
				</div>
			</div>
			<MonitoringCenterList
				flatData={flatData}
				onLoadMore={getNextPage}
				onRefresh={loadData}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
			/>
		</div>
	);
};

export default MonitoringCenterNewRequestsItemDetail;
